import React from "react";
import { Stack, Link } from "@mui/material";
import { FunctionField } from "react-admin";
import { DateTime } from "luxon";

import { PaymentAttachment } from "../api/payments";
import { getApiBase } from "../utils/api";

const collectInvoices = (record: any): PaymentAttachment[] => {
  const invoices: PaymentAttachment[] = [];
  if (record?.invoice) invoices.push(record.invoice);
  if (Array.isArray(record?.attachments)) invoices.push(...record.attachments);
  return invoices;
};

export const formatPaymentInvoiceLabel = (invoice: PaymentAttachment, index: number) => {
  const baseLabel = `請求書${index + 1}`;
  const latestDownload = invoice.latest_download;
  if (!latestDownload) return baseLabel;

  const downloadedDate = DateTime.fromISO(latestDownload.downloaded_at, { setZone: true }).toFormat("yyyy/LL/dd");
  return `${baseLabel}（${downloadedDate} ${latestDownload.downloaded_by_name}）`;
};

export const PaymentInvoicesField = ({ label }: { label: string }) => (
  <FunctionField
    source="invoice"
    label={label}
    sortable={false}
    render={(record: any) => {
      const invoices = collectInvoices(record);
      if (invoices.length === 0) return null;

      return (
        <Stack spacing={0.5} alignItems="flex-start">
          {invoices.map((invoice: any, index: number) => (
            <Link
              key={invoice.uuid || `invoice-${index}`}
              href={`${getApiBase()}/attachments?uuid=${invoice.uuid}`}
              target="_blank"
              rel="noreferrer"
              sx={{ whiteSpace: "nowrap" }}
              onClick={(event) => event.stopPropagation()}
            >
              {formatPaymentInvoiceLabel(invoice, index)}
            </Link>
          ))}
        </Stack>
      );
    }}
  />
);
